import React from "react";
import { Select } from 'antd';
const { Option } = Select;
import './index.scss'

class DropMenu extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    render() {
        return (
            <div className='progress-dropdown'>
                <Select
                    style={{ width: 80 }}
                    value={this.props.progressName}
                    className="operate-select"
                    onChange={this.handleChange}
                >
                    {this.props.list.map(item => {
                        return (<Option key={item.id} value={item.id + '-' + item.name}>{item.name}</Option>)
                    })}
                </Select>
            </div>
        )
    }
    handleChange = (e) => {
        this.props.changeComponent(e)
    }
}
const mapStateToProps = (state) => {
    return {
        ...state.Common,
    };
};

export default DropMenu
